import { combineReducers } from "redux";

import totalservices from "../features/admin/dashboard/totalservices/Slice";

import totalenquirys from "../features/admin/dashboard/totalenquirys/Slice";

import totalcontacts from "../features/admin/dashboard/totalcontacts/Slice";

import totalbusiness from "../features/admin/dashboard/totalbusiness/Slice";

import common from "../features/admin/common/Slice";

const dashboard = combineReducers({
  totalservices,
  totalenquirys,
  totalcontacts,
  totalbusiness,
  common
});

export default dashboard;
